module.exports = __webpack_public_path__ + "img/top3_img1.3c52ddf9.png";